import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Root from "./Root";

const Routing = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={"/:firstParam/:secondParam/:thirdParam/:fourthParam"} element={<Root />} />
                <Route path={"/:firstParam/:secondParam/:thirdParam"} element={<Root />} />
                <Route path={"/:firstParam/:secondParam"} element={<Root />} />
                <Route path={"/:firstParam"} element={<Root />} />
                <Route path={"/"} element={<Root />} />
            </Routes>
        </BrowserRouter>
    );
};

export default Routing;
